import React, { useEffect, useState, useContext } from "react"

import ModalComponent from "../ModalComponent"
import { TabEditAndHistory } from "../TabEditAndHistory"
import intl from "react-intl-universal"
import styles from "./index.module.scss"
import SwitchComponent from "../../../../atoms/Switch"
import Button from "../../../../atoms/Button"
import { WestgardRules } from "../WestgardRules"
import { getWestGardRoles } from "../../../../../services/ciq"
import RcmpLoading from "../../../../atoms/Loading"
import { MaximunImprecisun } from "../MaximunImprecisiun"
import { ControlsContext } from "../../../../../contexts/Controls"
import Input from "../../../../atoms/Input"
import { ArrowDownRed } from "../../../../../assets/icons/ArrowDownRed"
import { ArrowUpGreen } from "../../../../../assets/icons/ArrowUpGreen"
import { OptionsResultsControl } from "../OptionsResultsControl"
import { listHistory } from "../../../../../services/ciq"
import { fnFormatDateFromUTC } from "../../../../../utils/date"
import AuthContext from "../../../../../contexts/Auth"
import { HistoryComponent } from "../HistoryComponent"
import { useParams } from "react-router-dom"

export const ModalSettingsControl = ({
  tableBodyArray,
  setTableBodyArray,
  setbIsOpenModalSettingsEquiment,
  isTabEdit,
  setIsTabEdit,
  isSwitchSuspense,
  setIsSwitchSuspense,
  setIsCheckedSwitch,
  setIsChanged,
}) => {
  const [bIsError, setBIsError] = useState({
    bIsErrorStandardDeviation: false,
    bIsErrorStandardDeviationEqualsZero: false,
    bIsErrorAvarage: false,
  })
  const [dataHistory, setDataHistory] = useState([])
  const [isLoadHistory, setIsLoadHistory] = useState(false)
  const [infoInfinitScroll, setInfoInfinitScroll] = useState({})
  const [per_pageHistory, setPerPageHistory] = useState(1)
  const [search_type, setSearchType] = useState("")
  const [text_type, setTextType] = useState("")

  const { oUser } = useContext(AuthContext)
  const cUserTimeZone = oUser?.data?.user_ctimezone
  const { id } = useParams()

  const { dataConfigAnalyte, setDataConfigAnalyte } = useContext(ControlsContext)

  const [cAverage, setCAverage] = useState(
    String(dataConfigAnalyte?.eqpanlt_naverage || 0),
  )
  const [cStandardDeviation, setCStandardDeviation] = useState(
    String(dataConfigAnalyte?.eqpanlt_nstandard_deviation || 0),
  )

  useEffect(() => {
    setCStandardDeviation(String(dataConfigAnalyte?.eqpanlt_nstandard_deviation || 0))
    setCAverage(String(dataConfigAnalyte?.eqpanlt_naverage || 0))
  }, [])

  const fnHandleChange = (e, callback) => {
    let value = e.target.value.replace(/[^0-9,]/g, "")

    const partes = value.split(",")
    if (partes.length > 2) {
      value = partes[0] + "," + partes[1]
    }

    // ate 5 casas decimais
    if (value.slice(value.indexOf(",") + 1).length <= 5) {
      callback(value)
    }
  }

  const fnLowerInterval = () => {
    const valueAvarage = Number(cAverage?.replace(",", "."))

    const valueStandardDeviation = Number(cStandardDeviation?.replace(",", "."))

    const nCAverageDecimalsCount = countDecimals(valueAvarage) || 1
    const value = Number(valueAvarage - (2 * valueStandardDeviation))?.toLocaleString('fullwide', { maximumFractionDigits: nCAverageDecimalsCount })
    return value != "NaN" ? value : 0
  }
  const fnUpperInterval = () => {
    const valueAvarage = Number(cAverage?.replace(",", "."))

    const valueStandardDeviation = Number(cStandardDeviation?.replace(",", "."))
    const nCStandardDeviationDecimalsCount = countDecimals(valueStandardDeviation) || 1
 
    const value = Number(valueAvarage + (2 * valueStandardDeviation))?.toLocaleString('fullwide', { maximumFractionDigits: nCStandardDeviationDecimalsCount })
    return value != "NaN" ? value : 0
  }

  const countDecimals = (value) => {
    if(Math.floor(value?.valueOf()) === value?.valueOf()) return 0;
    return String(value)?.split(".")?.[1]?.length || 0; 
  }

  useEffect(() => {
    if (!Object.keys(dataConfigAnalyte).includes("eqpanlt")) {
      setDataConfigAnalyte((oldState) => {
        const dataConfigAnalyte = {
          eqpanlt: oldState,
        }
        return dataConfigAnalyte
      })
    }

    setIsTabEdit(true)
  }, [])

  const getHistoricHistoric = async (id, perPage, searchType, textType) => {
    try {
      setDataHistory([])
      setIsLoadHistory(true)
      const { data: dt } = await listHistory(
        id,
        perPage,
        searchType,
        textType,
        "control-analyte",
      )

      const newDataHistory = dt.data.data.map((item) => {
        const [data, hour] = fnFormatDateFromUTC(
          item.history_dupdated,
          "DD/MM/YYYY - HH:mm",
          cUserTimeZone,
        ).split(" - ")

        return {
          ...item,
          history_caction: item.history_caction,
          history_data: data,
          history_hour: hour,
          history_user_cname: item.history_user?.cname,
        }
      })

      setDataHistory(newDataHistory)

      setInfoInfinitScroll({
        last_page: dt.data.last_page,
        next_page_url: dt.data.next_page_url,
        data_length: dt.data.data.length,
      })
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadHistory(false)
    }
  }

  useEffect(() => {
    getHistoricHistoric(
      dataConfigAnalyte.eqpanlt_nid,
      per_pageHistory,
      search_type,
      text_type,
    )
  }, [dataConfigAnalyte.eqpanlt_nid, per_pageHistory, search_type, text_type])

  return (
    <ModalComponent
      title={intl.get("ciq.settings_analyte")}
      fnCloseModal={() => setbIsOpenModalSettingsEquiment(false)}
      size={isTabEdit ? "lg" : "xlg"}
    >
      <TabEditAndHistory isTabEdit={isTabEdit} handleActive={setIsTabEdit} />

      {isTabEdit ? (
        <>
          <div className={`${styles.flexBetween} ${styles.mbTwoRem}`}>
            <h3 className={styles.titleConfig}>
              {intl.get("ciq.status_analyte_linked_control")}
            </h3>

            <SwitchComponent
              width="10rem"
              label="Status"
              onClick={() => {
                setIsSwitchSuspense((oldState) => !oldState)
                setIsChanged(true)
              }}
              cDisabledText={intl.get("ciq.inactive_up")}
              cAbleText={intl.get("ciq.active_up")}
              value={isSwitchSuspense}
            />
          </div>

          <div className={styles.flexStart}>
            <div className={`${styles.containerContent} ${styles.widthFiveRem}`}>
              <p className={styles.label}>ID</p>
              <p className={styles.content}>{dataConfigAnalyte?.eqpanlt?.anlt_nid}</p>
            </div>
            <div className={`${styles.containerContent} ${styles.widthTenRem}`}>
              <p className={styles.label}>
                {intl.get("ciq.header_table_list_equipment.name")}
              </p>
              <p className={styles.content}>{dataConfigAnalyte?.eqpanlt?.anlt_cname}</p>
            </div>
            <div className={styles.containerContent}>
              <p className={styles.label}>
                {intl.get("ciq.header_table_link_analytes.type")}
              </p>
              <p className={styles.content}>{dataConfigAnalyte?.eqpanlt?.anlt_type}</p>
            </div>
            <div />
          </div>
          {dataConfigAnalyte?.eqpanlt?.anlt_type ===
            intl.get("ciq.types_analytes.quantitative") && (
            <div className={styles.flexStart}>
              <div className={`${styles.containerContent} ${styles.widthFiveRem}`}>
                <p className={styles.label}>Unidade</p>
                <p className={styles.content}>
                  {dataConfigAnalyte?.eqpanlt.anlt_unit_of_measure}
                </p>
              </div>
              <div className={`${styles.containerContent} ${styles.widthTenRem}`}>
                <p className={styles.label}>
                  {intl.get("ciq.header_table_list_analyte.sector")}
                </p>
                <p className={styles.content}>
                  {dataConfigAnalyte?.eqpanlt?.anlt_sector?.sector_cname}
                </p>
              </div>
              <div className={styles.containerContent}>
                <p className={styles.label}>
                  {intl.get("ciq.create_analytes.n_decimals")}
                </p>
                <p className={styles.content}>
                  {dataConfigAnalyte?.eqpanlt.anlt_decimal_places}
                </p>
              </div>
              <div />
            </div>
          )}
          <div className={styles.flexStart}>
            <div className={styles.containerContent}>
              <p className={styles.label}>
                {intl.get("ciq.header_table_list_equipment.observation")}
              </p>
              <p className={styles.content} style={{ fontWeight: 400 }}>
                {dataConfigAnalyte?.eqpanlt?.anlt_observation}
              </p>
            </div>
          </div>

          {dataConfigAnalyte?.eqpanlt?.anlt_type ===
          intl.get("ciq.types_analytes.quantitative") ? (
            <div
              className={`${styles.flexBetween} ${
                !isSwitchSuspense ? styles.opacity : ""
              }`}
            >
              <div
                className={`${styles.fullWidth} 
        ${bIsError.bIsErrorAvarage ? styles.error : ""}
        `}
              >
                <Input
                  label={intl.get("ciq.avarage")}
                  placeholder="0"
                  width="100%"
                  value={cAverage}
                  disabled={!isSwitchSuspense}
                  onChange={(e) => {
                    fnHandleChange(e, setCAverage)
                    setIsChanged(true)

                    if (!e.target.value !== "") {
                      setBIsError({
                        ...bIsError,
                        bIsErrorAvarage: false,
                      })
                    }
                  }}
                />

                <small
                  style={{ color: "red", display: bIsError.bIsErrorAvarage ? 'block' : 'none' }}
                >
                  {intl.get("form.required_field")}
                </small>
              </div>
              <div
                className={`${styles.fullWidth} 
        ${bIsError.bIsErrorStandardDeviation ? styles.error : ""}
        `}
              >
                <Input
                  label={intl.get("ciq.standard_deviation")}
                  placeholder="0"
                  width="100%"
                  disabled={!isSwitchSuspense}
                  value={cStandardDeviation}
                  onChange={(e) => {
                    fnHandleChange(e, setCStandardDeviation)
                    setIsChanged(true)

                    if (!e.target.value !== "") {
                      setBIsError({
                        ...bIsError,
                        bIsErrorStandardDeviation: false,
                      })
                    }

                    if (!e.target.value !== "0") {
                      setBIsError({
                        ...bIsError,
                        bIsErrorStandardDeviationEqualsZero: false,
                      })
                    } else {
                      setBIsError({
                        ...bIsError,
                        bIsErrorStandardDeviationEqualsZero: true,
                      })
                    }
                  }}
                />

                <small
                  style={{
                    color: "red",
                    display: (bIsError.bIsErrorStandardDeviation || bIsError.bIsErrorStandardDeviationEqualsZero) ? 'block' : 'none',
                  }}
                >
                  {bIsError.bIsErrorStandardDeviation && intl.get("form.required_field")}
                  {bIsError.bIsErrorStandardDeviationEqualsZero &&
                    intl.get("ciq.standard_deviation_equals_zero")}
                </small>
              </div>
              <div className={styles.containerInterval}>
                <p className={styles.center}>{intl.get("ciq.interval_info")}</p>

                <div className={styles.flexCenter}>
                  <span>
                    <ArrowDownRed style={{ marginRight: "0.5rem" }} />
                    {fnLowerInterval()}
                  </span>
                  <span>
                    <ArrowUpGreen style={{ marginRight: "0.3rem" }} /> {fnUpperInterval()}
                  </span>
                </div>
                <small style={{ opacity: 0 }}>{intl.get("form.required_field")}</small>
              </div>
            </div>
          ) : (
            dataConfigAnalyte?.eqpanlt?.anlt_result_options?.map((item, index) => {
              return (
                <OptionsResultsControl
                  index={index}
                  bdisabled={!isSwitchSuspense}
                  key={item.resultopt_nid}
                  oResults={item}
                  setIsChanged={setIsChanged}
                />
              )
            })
          )}
        </>
      ) : (
        <HistoryComponent
          searchHistory="analyte-control"
          history={dataHistory}
          infoInfinitScroll={infoInfinitScroll}
          setPerPage={setPerPageHistory}
          perPage={per_pageHistory}
          isLoadHistory={isLoadHistory}
          setSearchType={setSearchType}
          setSearchText={setTextType}
        />
      )}

      <div
        className={styles.flexBetween}
        style={{
          margin: "1rem 0 0 0",
        }}
      >
        <Button variant="outline" onClick={() => setbIsOpenModalSettingsEquiment(false)}>
          {intl.get("cancel")}
        </Button>
        <Button
          onClick={() => {
            if (cAverage === "" || cStandardDeviation === "") {
              if (cAverage === "" && cStandardDeviation === "") {
                setBIsError({
                  bIsErrorStandardDeviation: true,
                  bIsErrorAvarage: true,
                })
              } else if (cAverage === "") {
                setBIsError({
                  bIsErrorStandardDeviation: false,
                  bIsErrorAvarage: true,
                })
              } else if (cStandardDeviation === "") {
                setBIsError({
                  bIsErrorStandardDeviation: true,
                  bIsErrorAvarage: false,
                })
              }

              return
            }

            if (
              cStandardDeviation === "0" &&
              dataConfigAnalyte?.eqpanlt?.anlt_type?.toLowerCase() === "quantitativo"
            ) {
              setBIsError({
                bIsErrorStandardDeviationEqualsZero: true,
              })
              return
            }

            const newData = {
              ...dataConfigAnalyte,
              eqpanlt_naverage: +cAverage.replace(",", "."),
              eqpanlt_nstandard_deviation: +cStandardDeviation.replace(",", "."),
            }

            setIsCheckedSwitch(isSwitchSuspense)
            setbIsOpenModalSettingsEquiment(false)

            const dataConfig = {
              ...newData,
              anlt_bstatus:
                isSwitchSuspense === true ||
                isSwitchSuspense === "Ativo" ||
                isSwitchSuspense === "Active"
                  ? intl.get("ciq.list_analytes.active")
                  : intl.get("ciq.list_analytes.inactive"),
              status: isSwitchSuspense,
            }

            setDataConfigAnalyte(dataConfig)
            setIsChanged(true)

            const data = tableBodyArray.map((item) => {
              if (item.anlt_nid === dataConfig?.eqpanlt?.anlt_nid) {
                return {
                  ...item,
                  anlt_bstatus:
                    isSwitchSuspense === true ||
                    isSwitchSuspense === "Ativo" ||
                    isSwitchSuspense === "Active"
                      ? intl.get("ciq.list_analytes.active")
                      : intl.get("ciq.list_analytes.inactive"),
                }
              } else {
                return item
              }
            })

            // faz alteracao do imprecisao maxima
            setTableBodyArray(
              data.map((item) => {
                if (item.anlt_nid === dataConfig?.eqpanlt?.anlt_nid) {
                  return { ...item, ...dataConfig }
                } else {
                  return item
                }
              }),
            )
          }}
        >
          {intl.get("save_settings")}
        </Button>
      </div>
    </ModalComponent>
  )
}
